import FormSettings from './FormSettings/Index';

export default FormSettings;
